import React from 'react';
import PropTypes from 'prop-types';
import ScrollToNext from '@components/ScrollToNext';
import './style.scss';

const AboutPage = (props, context) => {
  const {
    theme: { colorPrimary, colorHighlight, bgPrimary, textPrimary }
  } = context;

  return (
    <div className="about-page" style={{ backgroundColor: bgPrimary }}>
      <style jsx="true">
        {`
          .highlight {
            background-color: ${colorHighlight};
          }
          ::selection {
            background-color: ${colorHighlight};
          }
        `}
      </style>
      <div className="content-grid">
        <h1 style={{ color: colorPrimary }}>About Me</h1>
        <div className="about-wrapper">
          <div className="about-content" style={{ color: textPrimary }}>
            <p></p>
            <p>
              I innovate in the nexus between people and technology.
                My passion is to make useful technology for people and organizations. I enjoy working on projects that transform complex data into insightful solutions.
            </p>
            <p></p>
            <p>
              My current skill focus is cross platform mobile development and complex data visualization.
                Along with a constantly growing stream of side projects, I intern at SAS Institute and
                develop the <span className="" >Campus Map</span> for Brigham Young University and
              </p>
            <p></p>
            <p>I am wrapping up a Masters degree in Information Systems Management. My studies have helped me answer the question: what gives data meaning, and technology impact?  </p>
            <p></p>
            <p>
              Flutter, Vue, Python, D3, and AWS
               are my go-to tools to get the job done.
            </p>
            <p></p>
            <p>
             If you are seeking a software solution or an employer looking to hire, you can get in touch with me here
              <a target="_blank" rel="noopener noreferrer" href="mailto:andyp3rkins@gmail.com" style={ { color: colorPrimary } }> <i className="fas fa-envelope"></i></a>
            </p>
            <p className="text-emoji" style={{ color: colorPrimary }}>
              {/* \ (•◡•) / */}
            </p>
          </div>
        </div>
      </div>
      <ScrollToNext pageSelector=".portfolio-page" />
    </div>
  );
};

AboutPage.contextTypes = {
  theme: PropTypes.any
};

export default AboutPage;



// WEBPACK FOOTER //
// ./src/pages/AboutPage/AboutPage.js